/**
 * Unwrap backend API envelope from axios responses.
 * @param {import('axios').AxiosResponse} response
 * @returns {unknown}
 */
export function unwrapApiResponse(response) {
  const body = response?.data;

  if (body == null || typeof body !== 'object') {
    return body;
  }

  if (!Object.prototype.hasOwnProperty.call(body, 'success')) {
    return body;
  }

  if (!body.success) {
    const detail =
      Array.isArray(body.errors) && body.errors.length > 0
        ? body.errors.join(' ')
        : body.message;
    throw new Error(detail || 'Request failed');
  }

  return body.data;
}


export function formatApiError(err, fallback = 'Request failed') {
  const body = err?.response?.data;
  if (body && typeof body === 'object') {
    if (body.success === false) {
      const parts = [body.message, ...(body.errors || [])].filter(Boolean);
      return parts.join(' ') || fallback;
    }
    if (typeof body.message === 'string') return body.message;
  }
  if (typeof err?.message === 'string') return err.message;
  return fallback;
}
